import React from "react";
import ReactDOM from "react-dom/client";
import {PerformanceMonitor} from "./utils/performance";
import {analytics} from "./utils/analytics";
import {HealthMonitor} from "./utils/monitoring";
import App from "./App";
import "./styles/index.css";

// Performance monitoring
PerformanceMonitor.startMeasurement("app-initialization");

// Global error handlers
window.addEventListener("error", (event) => {
    analytics.trackError(event.error, {
        context: "global-error",
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
    });
});

window.addEventListener("unhandledrejection", (event) => {
    analytics.trackError(new Error(event.reason), {
        context: "unhandled-promise-rejection",
    });
});

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

root.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
);

const initNonCritical = () => {
    // Initialize health monitoring
    HealthMonitor.registerCheck("dom", () => Promise.resolve(!!document.body));

    PerformanceMonitor.endMeasurement("app-initialization");

    if (import.meta.env.PROD) {
        import("web-vitals")
            .then(({onCLS, onINP, onLCP, onFCP, onTTFB}) => {
                onCLS((metric) => analytics.track("web_vital_cls", metric));
                onINP((metric) => analytics.track("web_vital_inp", metric));
                onLCP((metric) => analytics.track("web_vital_lcp", metric));
                onFCP((metric) => analytics.track("web_vital_fcp", metric));
                onTTFB((metric) => analytics.track("web_vital_ttfb", metric));
            })
            .catch(() => {
                // web-vitals not available
            });
    }

    analytics.track("app_loaded", {
        timestamp: Date.now(),
        viewport: `${window.innerWidth}x${window.innerHeight}`,
        connection: (navigator as unknown as Record<string, { effectiveType?: string }>).connection?.effectiveType ?? "unknown",
        deviceMemory: (navigator as unknown as Record<string, unknown>).deviceMemory ?? "unknown",
    });
};

if ("requestIdleCallback" in window) {
    requestIdleCallback(initNonCritical, {timeout: 2000});
} else {
    setTimeout(initNonCritical, 1);
}
